import axios from 'axios'
import { generatePath } from 'react-router-dom'
import { api } from '../config/api'
import { mercure_token, mercure_url } from '../config/config'
import store from '../config/store'
import {
  generateApiUrl,
  generateApiUrlWithGetParams,
  generateGetApiUrl,
  generateGetUrl,
} from '../utils/urlHelpers'
import { Methods, makeRequest } from './Request'

export const listFlowsSelect = (params = {}) => {
  const url = generateGetApiUrl(api.routes.flows.list_select, params)
  return makeRequest(url, Methods.GET)
}

export const associateScreenFlow = (screen, flow, method, data) => {
  const params = {
    screen: screen?.id,
    flow: flow?.id,
  }
  const url = generateApiUrl(api.routes.flows.associate_screen, params)
  return makeRequest(url, method, data)
}

export const getFlows = (params) => {
  let url = generateGetApiUrl(api.routes.flows.list, params)
  const { currentCompany } = store.getState().auth

  if (currentCompany) {
    url = generateApiUrlWithGetParams(
      api.routes.flows.listCompany,
      { companyId: currentCompany.id },
      false,
      params
    )
  }

  return makeRequest(url, Methods.GET)
}

export const getFlowDataSource = (id) => {
  const url = generateApiUrl(api.routes.flows.getDataSource, { id: id })
  return makeRequest(url, Methods.GET)
}

export const getFlow = (id) => {
  const url = generateApiUrl(api.routes.flows.get, { id: id })
  return makeRequest(url, Methods.GET)
}

export const initFlow = (id) => {
  const url = generateApiUrl(api.routes.flows.init, { id: id })
  return makeRequest(url, Methods.GET)
}

export const updateFlow = (id, params, method, shouldPublish) => {
  const url = generateApiUrl(api.routes.flows.get, { id: id })

  return makeRequest(
    url + (shouldPublish ? '?publish=true' : ''),
    method === 'PATCH' ? Methods.PATCH : Methods.POST,
    params,
    { 'Content-Type': 'multipart/form-data' }
  )
}

export const orderFlow = (companyId, ids) => {
  const url = generateApiUrl(api.routes.flows.order, { companyId })
  return makeRequest(url, Methods.POST, { ids })
}

export const orderFlows = (params) => {
  const url = generateApiUrl(api.routes.flows.order)
  return makeRequest(url, Methods.POST, params)
}

export const removeFlow = (flowId, companyId) => {
  const url = generateApiUrl(
    companyId ? api.routes.flows.removeFromCompany : api.routes.flows.remove,
    { id: flowId, companyId: companyId }
  )
  return makeRequest(url, Methods.DELETE)
}

export const removeFlowPart = (flowId) => {
  const url = generateApiUrl(api.routes.flows.removePart, { id: flowId })
  return makeRequest(url, Methods.DELETE)
}

export const getPreModelsList = () => {
  let url = generateApiUrl(api.routes.flows.list_models)
  const { currentCompany } = store.getState().auth

  if (currentCompany) {
    url = generateApiUrlWithGetParams(
      api.routes.flows.list_models_company,
      {
        companyId: currentCompany.id,
      },
      false,
      null
    )
  }

  return makeRequest(url, Methods.GET)
}

export const transformModelToFlow = (modelId, rootFlowId) => {
  let url = generateApiUrl(api.routes.flows.transform_model, {
    id: modelId,
    rootFlowId,
  })

  const { currentCompany } = store.getState().auth

  if (currentCompany) {
    url = generateApiUrlWithGetParams(
      api.routes.flows.transform_model_company,
      {
        companyId: currentCompany.id,
        id: modelId,
        rootFlowId,
      },
      false,
      null
    )
  }

  return makeRequest(url, Methods.POST)
}

export const getPreviewUrl = (flowId) => {
  const url = generateApiUrl(api.routes.flows.previewUrl, {
    id: flowId,
  })
  return makeRequest(url, Methods.GET)
}

export const getThumbnail = (flowId) => {
  const url = generateApiUrl(api.routes.flows.generateThumbnail, {
    flowId: flowId,
  })
  return makeRequest(url, Methods.GET)
}

export const getAreaData = (flowId, areaId, search) => {
  let url = generateApiUrl(api.routes.flows.getAreaData, {
    flowId: flowId,
    areaId: areaId,
  })
  url = generateGetUrl(url, search)

  return makeRequest(url, Methods.GET)
}

export const toggleExcludeAreaData = (flowId, areaId, id, search) => {
  let url = generateApiUrl(api.routes.flows.excludeAreaData, {
    flowId: flowId,
    areaId: areaId,
    id: id,
  })
  url = generateGetUrl(url, search)

  return makeRequest(url, Methods.DELETE)
}

export const fetchDataSource = (uri, flowId, areaId, data) => {
  uri = generatePath(uri, {
    flow_id: flowId,
    area_id: areaId,
  })
  return makeRequest(uri, Methods.POST, data, { from_initial_domain: true })
}

export const fetchScreensConnectivity = (screens) => {
  const requests = screens
    .filter((screen) => screen.uuid)
    .map((screen) => axios.get(
        `${mercure_url}/subscriptions/${encodeURIComponent(`screen_id/${screen.uuid}`)}`,
        {
          headers: {
            Authorization: `Bearer ${mercure_token}`,
          },
        }
      )
    )

  return axios.all(requests)
}
